// extracted by mini-css-extract-plugin
export default {"form-field-wrapper":"form-select_form-field-wrapper__U9OuB","error":"form-select_error__WzylU"};